"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandsExtension = void 0;
const core_1 = require("@remirror/core");
const remirror_1 = require("remirror");
class CommandsExtension extends core_1.PlainExtension {
    get name() {
        return 'squizCommands';
    }
    /**
     * Updates the attributes of a specific mark for the current selection.
     * Optionally, if text is provided it will replace the current selection.
     * The cursor will be place at the end of the selection after changes.
     *
     * @param {object} options
     */
    updateMark(options) {
        return (props) => {
            const { tr, dispatch, view } = props;
            const { mark, attrs, text, removeMark, range } = options;
            const selectedText = tr.doc.textBetween(range.from, range.to);
            if (text !== undefined && text !== selectedText) {
                // update the text in the editor if it was updated, update the range to cover the length of the new text.
                tr.insertText(text, range.from, range.to);
                range.to = range.from + text.length;
            }
            // apply the link, or remove it if no URL was provided.
            if (removeMark) {
                tr.removeMark(range.from, range.to, mark);
            }
            else {
                tr.addMark(range.from, range.to, mark.create(attrs));
            }
            // move the cursor to the end of the link and re-focus the editor.
            tr.setSelection((0, remirror_1.getTextSelection)({ from: range.to, to: range.to }, tr.doc));
            // apply the transaction.
            dispatch?.(tr);
            view?.focus();
            return true;
        };
    }
}
__decorate([
    (0, remirror_1.command)()
], CommandsExtension.prototype, "updateMark", null);
exports.CommandsExtension = CommandsExtension;
